import { api } from "./api";

const KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

function loadScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

/**
 * Collect payment for a request. With a real key it opens Razorpay checkout;
 * without one (demo) it captures directly via the backend's mock verify.
 * `payment` = { id, gateway_order_id, amount }.  Returns the verified payment.
 */
export async function payForRequest(payment, token, { name = "Customer", phone } = {}) {
  const amountRupees = Math.round(payment.amount);

  // demo / mock mode — no browser key -> straight to verify (backend trusts in mock)
  if (!KEY_ID || payment.gateway !== "razorpay") {
    return api("POST", `/rsa/payments/${payment.id}/verify`, { token, body: {} });
  }

  const ok = await loadScript();
  if (!ok) throw new Error("Could not load Razorpay checkout");

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: KEY_ID,
      order_id: payment.gateway_order_id,
      amount: amountRupees * 100,
      currency: payment.currency || "INR",
      name: "Avahan Roadside Assistance",
      description: "Emergency service fee",
      prefill: { name, contact: phone || "" },
      theme: { color: "#e63946" },
      handler: async (resp) => {
        try {
          const verified = await api("POST", `/rsa/payments/${payment.id}/verify`, {
            token,
            body: { razorpayPaymentId: resp.razorpay_payment_id, razorpaySignature: resp.razorpay_signature },
          });
          resolve(verified);
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.open();
  });
}
